import React from "react";

export const Change: React.FunctionComponent = () => (
	<section>
		<h1>Vesetranszplantációs Várólista Fórum - Szeptember 19.</h1>
		<p>Kedves Orvos és Szakdolgozó Kollégáink!</p>
		<p>
			Bár a jelentkezési határidő lejárt, a nagy érdeklődésre való
			tekintettel továbbra is várjuk az érdeklődők regisztrációját az
			alábbi email címen!{" "}
			<a href="mauilto:vesevarolista.bp@semmelweis.hu">
				vesevarolista.bp@semmelweis.hu
			</a>
			.
		</p>
		<p>
			Szeretettel hívunk minden érdeklődőt 2025 szeptember 19-én a
			Semmelweis Egyetem Sebészeti Transzplantációs és Gasztroenterológiai
			Klinikán “Vesetranszplantációs Várólista: Információk és tudnivalók”
			témában megrendezésre kerülő fórumra.
		</p>
		<p>Részvételükre feltétlenül számítunk!</p>
		<p>
			Üdvözlettel, <br />
			Budapesti Vesetranszplantációs Várólista Bizottság
		</p>
	</section>
);
